export default __webpack_public_path__ + "static/media/img2.b3bd3a4a.jfif";